import React from 'react';
import './terms-conditions.css';

const KycAndPmla = () => {
  return (
    <div className="tc-container">
      <header className="tc-header mb-3">
        <h1>Customer KYC & PMLA Policy</h1>
      </header>

      <section className="tc-content mb-3">
        <h5 className="text-center mb-4"><b>MARATHON FINLEASE PRIVATE LIMITED</b></h5>

        <h2>1. Preamble</h2>
        <p>
          The Reserve Bank of India (RBI) has issued guidelines regarding Know Your Customer (KYC) standards 
          and Anti-Money Laundering (AML) measures. <b>MARATHON FINLEASE PRIVATE LIMITED ("The Company")</b> 
          has adopted this policy to ensure compliance with the Prevention of Money Laundering Act, 2002 (PMLA) 
          and RBI’s Master Direction on KYC.
        </p>

        <h2>2. Objectives and Scope</h2>
        <p>
          The primary objective is to prevent the Company from being used, intentionally or unintentionally, 
          by criminal elements for money laundering or terrorist financing activities. This policy applies 
          to all customers and transactions handled by the Company.
        </p>

        <h2>3. Customer Acceptance Policy (CAP)</h2>
        <ul>
          <li>No account shall be opened in an anonymous or fictitious/benami name.</li>
          <li>Customers will be classified into risk categories (Low, Medium, High) based on their profile.</li>
          <li>Services will only be provided after verifying the customer's identity using Officially Valid Documents (OVD).</li>
          <li>The Company ensures that due diligence does not result in the denial of services to genuine customers.</li>
        </ul>

        <h2>4. Customer Identification Procedures (CIP)</h2>
        <p>
          The Company shall obtain sufficient information necessary to verify the identity of each new customer. 
          For <b>CreditPlate</b> (our digital lending brand), we primarily focus on Aadhaar-based e-KYC or 
          digital verification as per RBI norms.
        </p>

        <h2>5. Mandatory KYC Documents</h2>
        <h5 className="mt-3"><b>A. For Individuals</b></h5>
        <p><b>Proof of Identity & Address (Any one OVD):</b></p>
        <ul>
          <li>Aadhaar Card (Offline Verification/e-KYC)</li>
          <li>Voter ID Card</li>
          <li>Passport</li>
          <li>Driving License</li>
          <li>PAN Card (Mandatory for financial tracking)</li>
        </ul>

        <h5 className="mt-3"><b>B. For Companies/Firms</b></h5>
        <ul>
          <li>Certificate of Incorporation & MOA/AOA.</li>
          <li>PAN Card of the entity.</li>
          <li>Board Resolution authorizing the transaction.</li>
          <li>Identity and Address proof of the authorized signatories/Directors.</li>
        </ul>

        <h2>6. Monitoring and Reporting</h2>
        <p>
          The Company monitors transactions to identify unusual patterns that have no apparent economic 
          purpose. High-risk accounts are subject to intensified monitoring.
        </p>
        <ul>
          <li><b>Suspicious Transaction Reporting (STR):</b> Any suspicious activity will be reported to the Financial Intelligence Unit-India (FIU-IND).</li>
          <li><b>Principal Officer:</b> A designated officer is responsible for ensuring overall compliance with the PMLA guidelines.</li>
        </ul>

        <h2>7. Risk Management</h2>
        <p>
          Internal audit and compliance functions play a crucial role in evaluating adherence to KYC policies. 
          The Company conducts ongoing employee training so that staff members are adequately trained in 
          KYC/AML/CFT procedures.
        </p>

        <h2>8. Maintenance of Records</h2>
        <p>
          As per PMLA requirements, the Company will maintain records of all transactions and customer 
          identification data for at least <b>five (5) years</b> (or as amended by law) from the date of 
          cessation of the transaction/relationship.
        </p>

        <h2>9. Contact for Grievances</h2>
        <p>
          Borrowers are requested to address all grievances at the first instance to the Grievance Redressal Officer (GRO).
        </p>
        <p>
          <b>Grievance Redressal Officer</b><br />
          <b>Name:</b> Shivani Chaudhary<br />
          <b>Designation:</b> Sanction Head<br />
          <b>Company:</b> Marathon Finlease Private Limited (Fundswalle)<br />
          <b>Address:</b> Office no. 304, Laxman Palace, Delhi<br />
          <b>Contact Number:</b> 8800750038<br />
          <b>Email:</b> shivani@fundswalle.com
        </p>
        <p>
          <b>Nodal Officer</b><br />
          <b>Name:</b> Mr. Puneet Dixit<br />
          <b>Designation:</b> Chief Operating Officer<br />
          <b>Company:</b> Marathon Finlease Private Limited (Fundswalle)<br />
          <b>Address:</b> Office no. 304, Laxman Palace, Delhi<br />
          <b>Contact Number:</b> 9599894600<br />
          <b>Email:</b> puneet.dixit@fundswalle.com
        </p>
      </section>
    </div>
  );
};

export default KycAndPmla;